<template>
  <v-container fluid class="pa-0">
    <v-row align="center" justify="space-between" class="mb-5">
      <v-col cols="12" class="d-flex justify-space-between align-center">
        <div>
          <div class="page-title">Intern Feedback</div>
          <div class="page-subtitle">View feedbacks by HTE's to interns.</div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" class="flex-items mt-2">
        <v-tabs v-model="activeTab" color="#00A63E" align-tabs="left">
          <v-tab
            v-for="tab in tabList"
            :value="tab.name"
            :key="tab.id"
            @click="changeTab(tab)"
            >{{ tab.name }}</v-tab
          >
        </v-tabs>
      </v-col>
      <v-col cols="12">
        <v-card flat rounded="xl" class="table-card">
          <div class="d-flex align-center justify-space-between pa-4">
            <div>
              <div class="card-title">Feedback List</div>
              <v-chip
                size="x-small"
                color="#00A63E"
                variant="tonal"
                class="mt-1"
                >{{ tabledata.length }} feedback/s</v-chip
              >
            </div>
            <v-text-field
              v-model="search"
              placeholder="Search..."
              prepend-inner-icon="mdi-magnify"
              variant="outlined"
              density="compact"
              hide-details
              clearable
              style="max-width: 280px"
            />
          </div>
          <v-divider />
          <v-data-table
            :headers="headers"
            :items="tabledata"
            :search="search"
            :loading="loading"
            hover
            class="rounded-b-xl"
          >
            <!-- Date column -->
            <template v-slot:[`item.createdAt`]="{ item }">
              <div class="date-cell">
                <v-icon size="13" class="date-icon"
                  >mdi-calendar-outline</v-icon
                >
                <span class="date-text">{{ formatDate(item.createdAt) }}</span>
              </div>
            </template>

            <!-- Status column -->
            <template v-slot:[`item.status`]="{ item }">
              <div class="d-flex justify-center align-center ga-2">
                <div class="status-chip" :class="getStatusClass(item.status)">
                  <span class="status-dot"></span>
                  <span class="status-text">{{
                    getStatusLabel(item.status)
                  }}</span>
                </div>
                <div
                  class="type-badge"
                  :class="
                    item.feedback_type === 'concern'
                      ? 'type-concern'
                      : 'type-general'
                  "
                >
                  {{ item.feedback_type === "concern" ? "Concern" : "Comment" }}
                </div>
              </div>
            </template>

            <!-- Interns column -->
            <template v-slot:[`item.interns`]="{ item }">
              <div class="intern-chips">
                <div class="intern-chip" v-for="i in item.interns" :key="i.id">
                  <div class="intern-avatar-sm">
                    {{ getInitial(i.student.fname, i.student.lname) }}
                  </div>
                  <span class="intern-chip-name">{{
                    i.student.fname + " " + i.student.lname
                  }}</span>
                </div>
              </div>
            </template>
            <template v-slot:[`item.status_`]="{ item }">
              <div
                v-if="item.feedback_type == 'concern' && tab != 3"
                class="type-badge type-concern"
              >
                Action needed
              </div>
            </template>

            <!-- Actions column -->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="action-group">
                <button class="action-btn btn-view" @click="viewItem(item)">
                  <v-icon size="13">mdi-eye-outline</v-icon>
                  View
                </button>
              </div>
            </template>

            <!-- No data -->
            <template v-slot:no-data>
              <div class="empty-state">
                <div class="empty-icon-wrap">
                  <v-icon size="32" color="#d1d5db"
                    >mdi-comment-off-outline</v-icon
                  >
                </div>
                <div class="empty-title">No feedback yet</div>
                <div class="empty-subtitle">
                  Feedback submitted for interns will appear here.
                </div>
              </div>
            </template>

            <!-- Loading -->
            <template v-slot:loading>
              <div class="loading-state">
                <v-progress-circular
                  indeterminate
                  color="#00A63E"
                  size="28"
                  width="2"
                />
                <span class="loading-text">Loading feedbacks...</span>
              </div>
            </template>

            <!-- sdasd -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogConfirmDelete" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this feedback?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ViewCompanyFeedbackDialog :data="itemData" :action="action" :tab="tab" />
    <ViewCompanyFeedbackPreviewDialog
      :data="itemData1"
      :action="action"
      :tab="tab"
    />

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </v-container>
</template>

<script>
import eventBus from "@/eventBus";
import ViewCompanyFeedbackDialog from "../Dialogs/Views/ViewCompanyFeedbackDialog.vue";
import ViewCompanyFeedbackPreviewDialog from "../Dialogs/Views/ViewCompanyFeedbackPreviewDialog.vue";

export default {
  components: {
    ViewCompanyFeedbackDialog,
    ViewCompanyFeedbackPreviewDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    search: "",

    size: 200,
    headers: [
      { title: "Date", value: "createdAt", align: "start" },
      { title: "Status", value: "status", align: "center" },
      { title: "Interns", value: "interns", width: 300, align: "center" },
      { title: "", value: "status_", align: "start" },

      {
        title: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        width: 200,
      },
    ],
    data: [],
    activeTab: { id: 1, name: "Pending" },
    tab: 1,
    tabList: [
      { id: 1, name: "Pending" },
      { id: 2, name: "Acknowledged" },
      { id: 3, name: "Resolved" },
    ],
    skillsList: [],
    selectedSkills: [],
    programs_for: [],
    programSelected: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    expandTab1: false,
    expandTab2: false,
    programs: [],
    num_interns: null,
    showStudentMatching: false,
    itemData: null,
    viewData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    tabledata: [],
    creds: null,
    deleteData: null,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
    itemData1: null,
  }),
  mounted() {
    this.initialize();
    eventBus.on("closeFeedbackDialog", () => {
      this.initialize();
    });
  },
  beforeUnmount() {
    eventBus.off("closeFeedbackDialog");
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },

    getStatusLabel(status) {
      const map = { 1: "Pending", 2: "Acknowledged", 3: "Resolved" };
      return map[status] || "Unknown";
    },

    getStatusClass(status) {
      const map = {
        1: "status-pending",
        2: "status-acknowledged",
        3: "status-resolved",
      };
      return map[status] || "";
    },

    getInitial(fname, lname) {
      return ((fname?.[0] || "") + (lname?.[0] || "")).toUpperCase();
    },

    changeTab(tab) {
      this.activeTab = tab.name;
      this.tab = tab.id;
      this.initialize();
    },

    initialize() {
      this.axiosCall(
        "/organization-intern-feedback/getByInstitute/" + this.tab,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("sds  ", res.data);
          this.tabledata = res.data;
        }
      });
    },

    getProgramNames(programs) {
      let arr = [];
      for (let i = 0; i < programs.length; i++) {
        for (let j = 0; j < this.programs.length; j++) {
          if (programs[i] == this.programs[j].id) {
            arr.push(this.programs[j].abbr);
          }
        }
      }
      return arr;
    },

    addFeedback() {
      this.itemData = { id: null };
      this.action = "Add";
    },

    async save() {
      let validate = await this.$refs.InternRequestForm.validate();
      if (validate.valid) {
        if (this.programSelected.length == 0) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Please select program.";
        } else {
          let data = {
            programSelected: JSON.stringify(this.programSelected),
            num_interns: this.num_interns,
            skills: JSON.stringify(this.selectedSkills),
          };

          this.axiosCall("/organization/add-intern-request", "POST", data).then(
            (res) => {
              if (res.data.status == 201) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
                this.showStudentMatching = true;
              } else if (res.data.status == 400) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
              }
            },
          );
        }
      }
    },

    viewItem(item) {
      if (this.tab == 3) {
        this.itemData1 = item;
      } else {
        if (this.tab == 2 && item.feedback_type === "general") {
          this.itemData1 = item;
        } else {
          this.itemData = item;
        }
      }
      this.action = "View";
    },

    editItem(item) {
      this.itemData = item;
      this.action = "Update";
    },
    deleteItem(item) {
      this.deleteData = item;
      this.dialogConfirmDelete = true;
    },

    confirmDelete() {
      this.axiosCall(
        "/organization-intern-feedback/" + this.deleteData.id,
        "DELETE",
      ).then((res) => {
        if (res.data.status == 200) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.deleteData = null;
          this.initialize();
        } else if (res.data.status == 400) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },
  },
};
</script>

<style scoped>
/* ── Page header ── */
.page-title {
  font-size: 28px;
  font-weight: 800;
  color: #111827;
  letter-spacing: -0.5px;
  line-height: 1.1;
}
.page-subtitle {
  font-size: 13.5px;
  color: #6b7280;
  margin-top: 3px;
}
.add-btn {
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
  box-shadow: 0 4px 14px rgba(0, 166, 62, 0.3) !important;
  transition: all 0.18s ease !important;
}
.add-btn:hover {
  box-shadow: 0 6px 20px rgba(0, 166, 62, 0.42) !important;
  transform: translateY(-1px);
}

/* ── Table card ── */
.table-card {
  border: 1px solid #e5e7eb !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06) !important;
  overflow: hidden;
}

/* ── Card header ── */
.card-header {
  background: #fff;
}
.header-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #f0fdf4;
  border: 1px solid #d1fae5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.card-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.1px;
}
.card-meta {
  margin-top: 2px;
  font-size: 12px;
}
.feedback-count {
  font-weight: 700;
  color: #00a63e;
}
.feedback-label {
  color: #9ca3af;
}
.table-divider {
  opacity: 1;
  border-color: #f3f4f6 !important;
}
.search-field :deep(.v-field) {
  border-radius: 10px !important;
  font-size: 13px !important;
}

/* ── Table ── */
.feedback-table :deep(thead tr th) {
  background: #f9fafb !important;
  color: #6b7280 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 12px 16px !important;
}
.feedback-table :deep(tbody tr td) {
  padding: 14px 16px !important;
  border-bottom: 1px solid #f9fafb !important;
  font-size: 13.5px;
  vertical-align: middle;
}
.feedback-table :deep(tbody tr:last-child td) {
  border-bottom: none !important;
}
.feedback-table :deep(tbody tr:hover td) {
  background: #f0fdf4 !important;
}

/* ── Date cell ── */
.date-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}
.date-icon {
  color: #9ca3af;
  flex-shrink: 0;
}
.date-text {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
}

/* ── Status chips ── */
.status-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1px;
  white-space: nowrap;
}
.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* Pending — amber */
.status-pending {
  background: #fffbeb;
  color: #92400e;
  border: 1px solid #fde68a;
}
.status-pending .status-dot {
  background: #f59e0b;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);
}

/* Acknowledged — blue */
.status-acknowledged {
  background: #eff6ff;
  color: #1e40af;
  border: 1px solid #bfdbfe;
}
.status-acknowledged .status-dot {
  background: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

/* Resolved — green */
.status-resolved {
  background: #f0fdf4;
  color: #14532d;
  border: 1px solid #bbf7d0;
}
.status-resolved .status-dot {
  background: #16a34a;
  box-shadow: 0 0 0 2px rgba(22, 163, 74, 0.2);
}

/* ── Type badge ── */
.type-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.2px;
  text-transform: uppercase;
}

.type-concern {
  background: #fff7ed;
  color: #9a3412;
  border: 1px solid #fed7aa;
}
.type-general {
  background: #f5f3ff;
  color: #4c1d95;
  border: 1px solid #ddd6fe;
}

/* ── Intern chips ── */
.intern-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.intern-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px 3px 4px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  transition: border-color 0.15s;
}
.intern-chip:hover {
  border-color: #bbf7d0;
  background: #f0fdf4;
}
.intern-avatar-sm {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #16a34a, #4ade80);
  color: white;
  font-size: 8px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.intern-chip-name {
  font-size: 11.5px;
  font-weight: 500;
  color: #374151;
  white-space: nowrap;
}

/* ── Action buttons ── */
.action-group {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: nowrap;
  justify-content: center;
}
.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 11px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  font-family: inherit;
}
.btn-edit {
  background: #eff6ff;
  color: #1d4ed8;
  border-color: #bfdbfe;
}
.btn-edit:hover {
  background: #dbeafe;
  border-color: #93c5fd;
}
.btn-view {
  background: #f0fdf4;
  color: #15803d;
  border-color: #bbf7d0;
}
.btn-view:hover {
  background: #dcfce7;
  border-color: #86efac;
}
.btn-delete {
  background: #fef2f2;
  color: #b91c1c;
  border-color: #fecaca;
}
.btn-delete:hover {
  background: #fee2e2;
  border-color: #fca5a5;
}

/* ── Empty state ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 52px 24px;
  gap: 8px;
}
.empty-icon-wrap {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}
.empty-title {
  font-size: 14px;
  font-weight: 700;
  color: #374151;
}
.empty-subtitle {
  font-size: 12.5px;
  color: #9ca3af;
  text-align: center;
  max-width: 240px;
}

/* ── Loading state ── */
.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px;
}
.loading-text {
  font-size: 13px;
  color: #9ca3af;
}

/* ── Delete dialog ── */
.delete-dialog {
  overflow: hidden;
}
.delete-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 24px;
}
.delete-icon-wrap {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.delete-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}
.delete-sub {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 2px;
}
.delete-body {
  padding: 16px 24px;
  font-size: 13.5px;
  color: #4b5563;
  line-height: 1.6;
}
.delete-actions {
  padding: 12px 20px !important;
  background: #f9fafb;
}
.cancel-btn {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #6b7280 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
}
.confirm-delete-btn {
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  border-radius: 8px !important;
}
</style>
